<div mat-dialog-title class="padding-10">
  <h2 class="padding-top-5 padding-right-15">
    {{ "QUICK_QUOTE" | translate }}
  </h2>
  <mat-icon [mat-dialog-close]="true" (click)="onClose()">
    <i class="fas fa-times"></i>
  </mat-icon>
</div>
<mat-dialog-content class="padding-5 margin-top-10">
  <div *ngIf="quoteData === null">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="quoteData !== null">
    <div class="qq-container_quote-card-second-section d-grid flex-space-between">
      <div class="qq-container_quote-card-symbol d-flex flex-center xxlarge medium-weight ">
        {{ quoteData.Symbol }}
      </div>
      <!-- <quote-type-dropdown [usecase]="'BALANCES'"></quote-type-dropdown> -->
    </div>
    <div *ngIf="showLink && !hasAgreed" class="large padding-5 center">
      <span>
        {{ "EXCHANGE_NAV_TEXT" | translate }}
        <a href="javascript:void(0)" role="link" (click)="redirectToExchangeAgreement()">{{ "EXCHANGE_NAV_LINK" |
          translate }}</a>
      </span>
    </div>
    <div class="small regular-weight qq-container_quote-card-title">
      {{ quoteData.Name }}
    </div>
    <span aria-level="1">
      <span class="large medium-weight" [ngClass]="{
          'positive icon-caret-up': quoteData.DayChangeValue > 0,
          'negative icon-caret-down': quoteData.DayChangeValue < 0
        }" *ngIf="quoteData.LastPrice">$</span>
      <span class="large medium-weight padding-right-5" [ngClass]="{
          'positive icon-caret-up': quoteData.DayChangeValue > 0,
          'negative icon-caret-down': quoteData.DayChangeValue < 0
        }">
        {{ quoteData.LastPrice | pershingDecimalFormatingPipe : "1.2-2" }}</span>
      <span class="small medium-weight" [ngClass]="{
          'positive icon-caret-up': quoteData.DayChangeValue > 0,
          'negative icon-caret-down': quoteData.DayChangeValue < 0
        }">
        <span>{{quoteData.DayChangeValue | pershingDecimalFormatingPipe: '1.2-2' }}</span>
        <span>(</span>{{ quoteData.DayChangePercent | pershingDecimalFormatingPipe : "1.2-2"
        }}<span>%)</span>
      </span>
      <span *ngIf="quoteData.IssueType !== 'MF'">
        <span *ngIf="quoteData.LastSaleVolume > 0">
          x {{ quoteData.LastSaleVolume }}</span><span class="margin-left-5 small light-weight">{{
          quoteData.LastSaleExchange }}
        </span>
      </span>
    </span>
    <hr />
    <div class="qq-container_quote-card-first-section d-grid flex-space-between"
      *ngIf="quoteData !== null && quoteData.IssueType !== 'MF'">
      <ng-container *ngTemplateOutlet="
          first_row;
          context: {
            border: false,
            value: quoteData.Bid,
            title: 'BIDSIZE',
            size: quoteData.BidSize,
            exchange: quoteData.BidExchange,
            quoteType: quoteData.IssueType
          }
        "></ng-container>
      <ng-container *ngTemplateOutlet="
          first_row;
          context: {
            border: true,
            value: quoteData.Ask,
            title: 'ASKSIZE',
            size: quoteData.AskSize,
            exchange: quoteData.AskExchange,
            quoteType: quoteData.IssueType
          }
        "></ng-container>
      <ng-container *ngTemplateOutlet="
          first_row;
          context: {
            border: true,
            value: quoteData.Volume,
            title: 'VOLUME',
            quoteType: quoteData.IssueType
          }
        "></ng-container>
    </div>
    <div class="qq-container_quote-card-second-section d-grid" *ngIf="quoteData !== null && quoteData.IssueType === 'MF'">
      <ng-container *ngTemplateOutlet="
          first_row;
          context: {
            border: false,
            value: quoteData.NAV,
            title: 'NAV',
            quoteType: quoteData.IssueType
          }
        "></ng-container>
      <ng-container *ngTemplateOutlet="
          first_row;
          context: {
            border: true,
            value: quoteData.POP,
            title: 'POP',
            quoteType: quoteData.IssueType
          }
        "></ng-container>
    </div>
    <hr />
    <div class="qq-container_quote-card-second-section d-grid">
      <ng-container *ngTemplateOutlet="
          second_row;
          context: {
            border: false,
            leftValue: quoteData.Open,
            rightValue: quoteData.Close,
            title: 'Open / Close'
          }
        "></ng-container>
      <ng-container *ngTemplateOutlet="
          second_row;
          context: {
            border: true,
            leftValue: quoteData._52WeekLow,
            rightValue: quoteData._52WeekHigh,
            title: '52 Week Range'
          }
        "></ng-container>
    </div>
    <hr />
    <div>
      <div *ngIf="chartImage">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
      <img [hidden]="chartImage" class="padding-5 center-block width-90" [src]="quoteData.ChartURL"
        alt="{{ 'CHART_UNAVAILABLE' | translate }}" (load)="this.chartImage = false" />
      <div *ngIf="displayTradeButton" class="center padding-5">
        <button (click)="tradeButtonNavigation()" color="primary" class="width-30" mat-flat-button>{{ 'TRADE' | translate }}</button>
      </div>
      <div class="row margin-top-10 width-95 qq-container_quote-card-subtitle">
        <div class="col-xs-12" [attr.aria-expanded]="showDisclaimers.toString()" tabindex="-1">
            <div class="regular-weight small" href="javascript:void(0);"  (keydown.space)="toggleDisclaimers()" (click)="toggleDisclaimers()" *ngIf="!isShowingDisclaimers()"><i class="far fa-angle-right fa-lg"></i>{{ "DISCLAIMER_TEXT" | translate }}</div>
            <div class="regular-weight small" href="javascript:void(0);" (keydown.space)="toggleDisclaimers()" (click)="toggleDisclaimers()" *ngIf="isShowingDisclaimers()"><i class="far fa-angle-down fa-lg"></i>
              {{ "DISCLAIMER_TEXT" | translate }}<br>
              <p role="presentation">
                {{ "QUOTEASOF" | translate }}
                {{ quoteData.LastPriceTime }}
                <br />
                <span *ngIf="!isRealTimePref" role="presentation">
                  <sup>†</sup> {{ "QUOTEDATAAGREEMENT" | translate }}</span>
              </p>
            </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="regular bold-weight center">
      <span *ngIf="fullQuoteUrl && showFullQuote">
        <a href="javascript:void(0)" (click)="redirectToFullQuote()">{{
          "VIEW_FULL_QUOTE" | translate
          }}</a>
      </span>
    </div>
  </div>
</mat-dialog-content>

<ng-template #first_row let-border="border" let-title="title" let-value="value" let-exchange="exchange" let-size="size"
  let-quoteType="quoteType">
  <div class="padding-left-10" [ngClass]="{ 'border-left': border }">
    <div class="small regular-weight qq-container_quote-card-subtitle">
      {{ title | translate }}
    </div>
    <div *ngIf="size!==undefined && exchange!==undefined" class="regular regular-weight">
      <span>$</span>{{ value | pershingDecimalFormatingPipe : "1.2-2" }}
      <span class="xsmall"><span *ngIf="size > 0 && quoteType !== 'MF'"> x {{ size }}</span><span
          class="margin-left-5 small light-weight">{{
          exchange
          }}</span></span>
    </div>
    <div *ngIf="size===undefined || exchange===undefined">
      <div *ngIf="quoteType !== 'MF'" class="regular regular-weight">
        {{ value | pershingDecimalFormatingPipe : "1.0-0" }}
      </div>
      <div *ngIf="quoteType === 'MF'" class="regular regular-weight">
        {{ value }}
      </div>
    </div>
  </div>
</ng-template>
<ng-template #second_row let-border="border" let-title="title" let-leftValue="leftValue" let-rightValue="rightValue">
  <div class="padding-left-10" [ngClass]="{ 'border-left': border }">
    <div class="small regular-weight qq-container_quote-card-subtitle">
      {{ title | translate }}
    </div>
    <div class="regular regular-weight">
      <span>$</span>{{ leftValue | pershingDecimalFormatingPipe : "1.2-2" }} /
      <span>$</span>{{ rightValue | pershingDecimalFormatingPipe : "1.2-2" }}
    </div>
  </div>
</ng-template>